/* ACROS configurator — Digital Nerds Media voor Pritec Automation
   Leest productdata en teksten uit de sectie (JSON), bouwt de stappen, stuurt offerte-aanvragen naar n8n
   en pusht meetgebeurtenissen naar de dataLayer. Alle teksten komen uit het taalbestand van het thema
   (vertaalbaar met Translate & Adapt); DEFAULTS hieronder is alleen een vangnet. */
(function () {
  'use strict';

  var DEFAULTS = {
      "nav_steps": "Stappen",
      "step_of": "Stap {n} van {total}",
      "parts_count": "{n} onderdelen",
      "step_1": "Snijwerk",
      "step_2": "Werkplaats",
      "step_3": "Advies",
      "step_4": "Toortsen",
      "step_5": "Extra's",
      "step_6": "Offerte",
      "boot_missing": "Voeg in de Theme Editor minimaal één snijtafel en één plasmasnijder toe aan deze sectie.",
      "boot_error": "De configurator kon niet laden.",
      "stage_eyebrow": "Jouw ACROS, live samengesteld",
      "stage_size": "Snijformaat {size}",
      "stage_rec": "Advies op basis van jouw antwoorden: ACROS {model} met {source}",
      "fp_label": "Snijformaat op schaal",
      "chips_label": "In jouw configuratie",
      "s1_title": "Wat wil je snijden?",
      "s1_intro": "Drie vragen over je snijwerk, daarna drie over je werkplaats.",
      "q_format": "1. Grootste plaatformaat dat je wilt snijden (mm)",
      "q_material": "2. Welk materiaal wil je snijden?",
      "q_thickness": "3. Welke plaatdikte wil je regelmatig met goede snijkwaliteit snijden?",
      "mat_staal": "Staal",
      "mat_rvs": "RVS",
      "mat_alu": "Aluminium",
      "mat_mix": "Verschillend",
      "mat_staal_lc": "staal",
      "mat_rvs_lc": "RVS",
      "mat_alu_lc": "aluminium",
      "mat_mix_lc": "verschillende materialen",
      "thick_1": "tot 6 mm",
      "thick_2": "6 – 12 mm",
      "thick_3": "12 – 20 mm",
      "thick_4": "meer dan 20 mm",
      "s2_title": "Jouw werkplaats",
      "s2_intro": "Zo sluit ons advies aan op hoe en waar je gaat snijden.",
      "q_intensity": "4. Hoe intensief ga je de machine gebruiken?",
      "int_inc": "Incidenteel",
      "int_inc_sub": "Reparatie en onderhoud",
      "int_reg": "Regelmatig",
      "int_reg_sub": "Korte series",
      "int_dag": "Dagelijks",
      "int_dag_sub": "Productiewerk",
      "q_power": "5. Welke stroomaansluiting heb je?",
      "power_0": "Weet ik niet",
      "power_9": "Anders",
      "power_other_label": "Andere stroomaansluiting",
      "power_other_ph": "Bijv. 400 V – 25 A",
      "q_air": "6. Welke persluchtvoorziening heb je?",
      "air_dry": "Geschikte compressor en droge perslucht",
      "air_cap": "Compressor aanwezig, capaciteit onbekend",
      "air_none": "Nog geen compressor",
      "air_unk": "Weet ik niet",
      "s3_title": "Ons advies",
      "kicker_model": "7. ACROS-model",
      "kicker_source": "8. Plasmasnijder",
      "other_size": "Ander formaat:",
      "brand_label": "Merk",
      "adjusted": "Door jou aangepast; ons advies is de {model}.",
      "reason_for": "Voor {list}.",
      "reason_quality": "{thickness} met goede snijkwaliteit",
      "reason_daily": "dagelijks productiewerk",
      "reason_power": "Aansluiting {power}.",
      "reason_q": "Goede snijkwaliteit tot {mm} mm.",
      "pros_pritec": "Pritec: langer aaneengesloten snijden, overzichtelijk LCD-scherm, goed bereikbare drukregelaar, kan gaas snijden.",
      "pros_jasic": "Jasic: handtoorts standaard inbegrepen.",
      "note_power": "Stroom: de {source} vraagt {need}. Jij hebt {have}. We nemen dit mee in de offerte.",
      "note_power_unknown": "Stroom: deze plasmasnijder vraagt {need}. We stemmen de aansluiting met je af.",
      "note_air_none": "Perslucht: je hebt nog geen compressor. Nodig is ca. 280 L/min bij 5,5 bar; we adviseren je in de offerte.",
      "note_air_check": "Perslucht: controleer of je compressor ca. 280 L/min bij 5,5 bar levert. Een luchtfilter is aanbevolen.",
      "note_thick": "Plaatdikte: voor deze dikte stemmen we het advies persoonlijk met je af.",
      "note_brand_light": "Voor jouw snijwerk is dit merk aan de lichte kant; ons advies is een zwaardere plasmasnijder van het andere merk.",
      "s4_title": "Toortsen en noodzakelijke onderdelen",
      "s4_intro": "De machinetoorts is nodig om CNC te snijden en staat al aangevinkt.",
      "torch_machine": "Machinetoorts",
      "torch_hand": "Handtoorts",
      "torch_machine_desc": "De toorts in de gantry: hiermee snijdt de Acros CNC.",
      "torch_hand_desc": "Ook met de hand snijden: omvormer loskoppelen en handtoorts aansluiten.",
      "tag_cnc": "Nodig voor CNC",
      "hand_included_desc": "Standaard meegeleverd bij deze plasmasnijder",
      "included": "Inbegrepen",
      "hand_included_line": "Handtoorts (inbegrepen)",
      "kit_desc": "Veelvoorkomende slijtdelen en reserveonderdelen voor een goede start.",
      "no_torches": "Voor deze plasmasnijder zijn geen losse toortsen nodig.",
      "s5_title": "Extra's",
      "s5_intro": "Optioneel. Alles is later ook los bij te bestellen.",
      "laptop_name": "Laptopsteun",
      "laptop_desc": "Bedien de software vanaf een laptop direct aan de machine.",
      "tag_recommended": "Aanbevolen",
      "more_info": "Meer info",
      "more_info_aria": "Meer info over {name} (opent in een nieuw tabblad)",
      "rim_desc": "Platen mogen oversteken; beschermt tegen spetters en vonken.",
      "strips_name": "Reserve snijstrips",
      "strips_each": "Per stuk {price}.",
      "strips_line": "Reserve snijstrips ({n}×)",
      "strips_less": "Eén snijstrip minder",
      "strips_more": "Eén snijstrip meer",
      "s6_title": "Levering en offerte",
      "s6_intro": "Een offerte op maat, inclusief actuele levertijd. Vrijblijvend.",
      "delivery_label": "Levering",
      "del_pickup": "Ophalen in Aalten",
      "del_pickup_sub": "Na afspraak",
      "del_deliver": "Bezorgen",
      "del_deliver_sub": "Kosten in offerte",
      "install_name": "Installatie en training op locatie",
      "price_in_quote": "Prijs in offerte",
      "in_quote": "In offerte",
      "sum_complete": "ACROS {model}, compleet",
      "sum_meta": "{n} onderdelen · {total} excl. btw",
      "spec_show": "Bekijk specificatie",
      "spec_hide": "Verberg specificatie",
      "answers_label": "Jouw snijwerk:",
      "ans_plate": "plaat {size} mm",
      "contact_q": "Hoe kunnen we je bereiken?",
      "contact_pref": "Contactvoorkeur",
      "contact_email": "E-mail",
      "contact_phone": "Telefoon",
      "label_email": "E-mailadres",
      "label_phone": "Telefoonnummer",
      "ph_email": "naam@bedrijf.nl",
      "ph_phone": "06 12345678",
      "label_name": "Naam of bedrijf (optioneel)",
      "privacy_text": "Je antwoorden sturen we mee, zodat de offerte meteen klopt. We gebruiken je gegevens alleen voor deze aanvraag.",
      "privacy_link": "Privacybeleid",
      "cart_text": "Liever direct bestellen?",
      "cart_link": "Zet deze configuratie in de winkelwagen",
      "done_title": "Aanvraag ontvangen",
      "done_text": "We sturen de offerte voor de ACROS {model} naar {contact}.",
      "done_next": "Wat er nu gebeurt",
      "done_1": "Je ontvangt een offerte op maat, inclusief levertijd.",
      "done_2": "Wil je de machine eerst zien? Plan een demonstratie in Aalten.",
      "done_3": "Wil je een eigen onderdeel of sample laten snijden? Vraag naar de mogelijkheden. Samples kunnen we ook naar je opsturen.",
      "demo_btn": "Plan je demo",
      "reset_btn": "Nieuwe configuratie",
      "foot_price": "Jouw prijs excl. btw",
      "foot_incl": "{price} incl. {vat}% btw",
      "btn_back": "Terug",
      "btn_next": "Volgende stap",
      "btn_advice": "Toon ons advies",
      "btn_to_offer": "Naar offerte",
      "btn_submit": "Offerte aanvragen",
      "btn_sending": "Versturen…",
      "err_webhook": "De aanvraag kan nog niet worden verstuurd. Bel ons op {phone}.",
      "err_send": "Versturen is niet gelukt. Probeer het opnieuw of bel ons op {phone}.",
      "err_send_fallback": "Versturen is niet gelukt. Stuur je aanvraag per e-mail; alles staat al voor je klaar.",
      "mail_btn": "Verstuur per e-mail",
      "thk_1": "tot 10 mm",
      "thk_2": "10 – 20 mm",
      "thk_3": "20 – 30 mm",
      "thk_4": "meer dan 30 mm",
      "del_ship": "Verzending via transporteur",
      "del_ship_sub": "Transportkosten in offerte",
      "tag_cnc_rec": "Aanbevolen voor CNC",
      "s4_intro2": "De machinetoorts geeft de beste snijkwaliteit en staat al aangevinkt.",
      "note_no_match": "Voor deze plaatdikte en dit materiaal stemmen we het advies persoonlijk met je af.",
      "reason_plate": "plaat {thickness}",
      "err_cart": "Toevoegen aan de winkelwagen lukte niet. Probeer het opnieuw of vraag een offerte aan.",
      "loading": "De configurator wordt geladen…",
      "noscript": "Zet JavaScript aan om de configurator te gebruiken."
  };

  var MATERIALS = [{ id: 'staal', swatch: '#5B6470' }, { id: 'rvs', swatch: '#C3C8CE' }, { id: 'alu', swatch: '#E1E4E8' }, { id: 'mix', swatch: '#8A9099' }];
  var THICKS = [{ id: 1, mm: 10, bar: 2 }, { id: 2, mm: 20, bar: 4 }, { id: 3, mm: 30, bar: 7 }, { id: 4, mm: 40, bar: 11 }];
  var INTENS = [{ id: 'inc', up: 0 }, { id: 'reg', up: 0 }, { id: 'dag', up: 1 }];
  var POWERS = [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 0 }, { id: 9 }];
  var POWER_LABEL = { 1: '230 V – 16 A', 2: '400 V – 16 A', 3: '400 V – 32 A' };
  var AIRS = [{ id: 'dry' }, { id: 'cap' }, { id: 'none' }, { id: 'unk' }];
  var DELIVERIES = [{ id: 'ship' }, { id: 'pickup' }];
  var ICON = {
    check: 'M5 12l5 5L20 7',
    warn: 'M12 9v4M12 16.5v.5M10.3 3.9L2 18a2 2 0 0 0 1.7 3h16.6a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z',
    arrow: 'M5 12h14M13 6l6 6-6 6',
    ext: 'M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5'
  };
  function icon(name, cls) { return '<svg class="ic' + (cls ? ' ' + cls : '') + '" viewBox="0 0 24 24" aria-hidden="true"><path d="' + ICON[name] + '"></path></svg>'; }
  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function find(list, id) { for (var i = 0; i < list.length; i++) { if (list[i].id === id) return list[i]; } return null; }
  function num(v, d) { var n = parseFloat(v); return isNaN(n) ? d : n; }
  function pick(variants, test) { for (var i = 0; i < variants.length; i++) { if (test(variants[i].title.toLowerCase())) return variants[i]; } return null; }
  function baseVariant(p) {
    if (!p || !p.variants.length) return null;
    return pick(p.variants, function (t) { return t.indexOf('zonder') > -1 || t.indexOf('without') > -1 || t.indexOf('ohne') > -1 || t === 'default title'; }) || p.variants[0];
  }

  function Configurator(root, data) {
    this.root = root;
    this.d = data;
    this.i18n = {};
    var raw = data.i18n || {}, ta = document.createElement('textarea');
    for (var k in raw) { if (raw[k] != null) { ta.innerHTML = raw[k]; this.i18n[k] = ta.value; } }
    /* Valuta: prijzen komen uit Liquid in de valuta van de bezoeker (Shopify Markets, bijv. SEK).
       base = winkelvaluta (EUR). rate = lokale valuta per 1 EUR, uit Shopify.currency (zelfde bron als de prijzen). */
    this.cur = data.currency || 'EUR';
    this.base = data.shopCurrency || 'EUR';
    this.rate = 1;
    if (this.cur !== this.base) {
      var sc = window.Shopify && window.Shopify.currency;
      var r = sc && sc.active === this.cur ? parseFloat(sc.rate) : NaN;
      this.rate = r > 0 ? r : null; /* null = koers onbekend: EUR-velden blijven leeg en n8n markeert het */
    }
    this.prepare();
    if (!this.tables.length || !this.sources.length) { root.innerHTML = '<div class="acfg__boot">' + esc(this.t('boot_missing')) + '</div>'; return; }
    this.state = this.initial();
    /* voorinvullen vanuit de promo-sectie: ?materiaal=staal&dikte=1..4 */
    try {
      var qp = new URLSearchParams(window.location.search), qd = parseInt(qp.get('dikte'), 10), qm = qp.get('materiaal');
      if (find(THICKS, qd)) this.state.thick = qd;
      if (qm && find(MATERIALS, qm)) this.state.material = qm;
    } catch (e) {}
    this.build();
    this.render();
    this.track('configurator_step', { configurator_step_number: 1, configurator_step_name: DEFAULTS.step_1 });
  }

  /* Tekst ophalen: eerst uit het taalbestand, anders de standaardtekst. {naam} wordt vervangen. */
  Configurator.prototype.t = function (key, vars) {
    var s = this.i18n[key];
    if (s == null || s === '') s = DEFAULTS[key] != null ? DEFAULTS[key] : key;
    if (vars) s = s.replace(/\{(\w+)\}/g, function (m, k) { return vars[k] != null ? vars[k] : m; });
    return s;
  };
  Configurator.prototype.powerLabel = function (id) { return id === 0 ? this.t('power_0') : id === 9 ? this.t('power_9') : POWER_LABEL[id]; };

  Configurator.prototype.initial = function () {
    return {
      step: 0, visited: 0,
      format: null, material: null, thick: null, intens: null, power: null, powerText: '', air: null,
      model: null, brand: this.d.defaultBrand || 'pritec', source: null,
      machineTorch: true, handTorch: false, kit: false, extras: {}, rim: false, laptop: false, strips: 0,
      delivery: 'ship', mode: 'email', contact: '', name: '', spec: false, sending: false, error: '', fallback: false
    };
  };

  Configurator.prototype.prepare = function () {
    var tables = [], sources = [], extras = [];
    (this.d.blocks || []).forEach(function (b) {
      if (!b.product) return;
      var p = b.product, img = b.image || p.image;
      if (b.type === 'table') {
        tables.push({
          id: b.id, label: b.label || p.title, len: num(b.len, 1000), width: num(b.width, 1000),
          formatLabel: b.formatLabel || '', fit: b.fit || '', img: img, product: p, base: baseVariant(p),
          laptop: pick(p.variants, function (t) { return t.indexOf('met laptop') > -1 || t.indexOf('with laptop') > -1 || t.indexOf('mit laptop') > -1; }),
          rim: b.rim, rimDesc: b.rimDesc || '', strip: b.strip, stripNote: b.stripNote || ''
        });
      } else if (b.type === 'source') {
        var hasMach = function (t) { return t.indexOf('machine') > -1 || t.indexOf('maschinen') > -1; };
        var hasHand = function (t) { return t.indexOf('hand') > -1; };
        sources.push({
          id: b.id, brand: b.brand || 'pritec', label: b.label || p.title, name: p.title.replace(/\s*(plasmasnijder|plasma cutter|plasmaschneider)\s*$/i, ''),
          amp: b.amp || '', power: parseInt(b.power, 10) || 2, level: parseInt(b.level, 10) || 2,
          q: { staal: b.qSteel, rvs: b.qRvs, alu: b.qAlu }, img: img, product: p, base: baseVariant(p),
          vMach: pick(p.variants, function (t) { return hasMach(t) && !hasHand(t); }),
          vHand: pick(p.variants, function (t) { return hasHand(t) && !hasMach(t); }),
          vBoth: pick(p.variants, function (t) { return hasHand(t) && hasMach(t); }),
          torch: b.torch, kit: b.kit, handIncluded: !!b.handIncluded
        });
      } else if (b.type === 'extra') {
        extras.push({
          id: b.id, name: b.label || p.title, desc: b.desc || '', recommend: b.recommend || 'none', product: p, variant: baseVariant(p),
          only: (b.onlyModels || '').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean)
        });
      }
    });
    tables.sort(function (a, b) { return a.len * a.width - b.len * b.width; });
    sources.sort(function (a, b) { return a.level - b.level || (a.base ? a.base.price : 0) - (b.base ? b.base.price : 0); });
    this.tables = tables; this.sources = sources; this.extras = extras;
    this.maxLen = Math.max.apply(null, tables.map(function (t) { return t.len; }).concat([1]));
    var minLen = Math.min.apply(null, tables.map(function (t) { return t.len; }).concat([this.maxLen]));
    var span = Math.max(1, this.maxLen - minLen);
    tables.forEach(function (t) { t.scale = (0.72 + 0.28 * (t.len - minLen) / span).toFixed(3); });
  };

  /* ---------- afgeleide waarden ---------- */
  Configurator.prototype.calc = function () {
    var s = this.state, self = this;
    var fmtTable = find(this.tables, s.format);
    var recTable = fmtTable || this.tables[Math.min(2, this.tables.length - 1)];
    var table = find(this.tables, s.model) || recTable;
    var mat = find(MATERIALS, s.material), thick = find(THICKS, s.thick), intens = find(INTENS, s.intens);
    /* Advies: goedkoopste snijder van het gekozen merk die de gevraagde dikte in het gekozen materiaal
       met goede kwaliteit snijdt. Dagelijks productiewerk: één stap zwaarder (inschakelduur). */
    var reqMm = thick ? thick.mm : 20, matId = mat ? mat.id : 'staal';
    var fits = function (x) { var q = self.quality(x, matId); return q == null ? x.level >= (thick ? thick.id : 2) : q >= reqMm; };
    var pickFrom = function (list) {
      for (var i = 0; i < list.length; i++) {
        if (fits(list[i])) return list[Math.min(list.length - 1, i + (intens && intens.id === 'dag' ? 1 : 0))];
      }
      return null;
    };
    var brandList = this.sources.filter(function (x) { return x.brand === s.brand; });
    if (!brandList.length) brandList = this.sources;
    var recSource = pickFrom(brandList);
    var otherFits = !recSource && !!pickFrom(this.sources.filter(function (x) { return x.brand !== s.brand; }));
    var noMatch = !recSource && !otherFits;
    var brandTooLight = !recSource && otherFits;
    if (!recSource) recSource = brandList[brandList.length - 1];
    var source = find(brandList, s.source) || recSource;

    var lines = [];
    function add(kind, name, variant, qty) {
      if (!variant) return;
      lines.push({ kind: kind, name: name, variantId: variant.id, sku: variant.sku, qty: qty || 1, price: variant.price * (qty || 1) });
    }
    var tVar = (s.laptop && table.laptop) ? table.laptop : table.base;
    add('table', 'ACROS ' + table.label + ' (' + this.sizeLabel(table) + ')', table.base, 1);
    if (s.laptop && table.laptop) lines.push({ kind: 'laptop', name: this.t('laptop_name'), price: table.laptop.price - table.base.price, qty: 1, cartSkip: true });

    var sVar = source.base, torchLines = [];
    var variantTorches = !!(source.vMach || source.vHand);
    if (variantTorches) {
      var m = s.machineTorch && source.vMach, h = s.handTorch && source.vHand;
      if (m && h) sVar = source.vBoth || source.vMach; else if (m) sVar = source.vMach; else if (h) sVar = source.vHand;
      if (m) torchLines.push({ kind: 'torch', name: this.torchName(source.vMach.title, this.t('torch_machine')), price: source.vMach.price - source.base.price, qty: 1, cartSkip: true });
      if (h) torchLines.push({ kind: 'torch', name: this.torchName(source.vHand.title, this.t('torch_hand')), price: source.vHand.price - source.base.price, qty: 1, cartSkip: true });
    }
    add('source', source.name, source.base, 1);
    lines = lines.concat(torchLines);
    if (!variantTorches && source.handIncluded) lines.push({ kind: 'torch', name: this.t('hand_included_line'), price: 0, qty: 1, cartSkip: true });
    if (!variantTorches && source.torch && s.machineTorch) add('torch', source.torch.title, baseVariant(source.torch), 1);
    if (source.kit && s.kit) add('kit', source.kit.title, baseVariant(source.kit), 1);

    var extras = this.extras.filter(function (e) { return !e.only.length || e.only.indexOf(table.label.toLowerCase()) > -1; });
    extras.forEach(function (e) { if (s.extras[e.id]) add('extra', e.name, e.variant, 1); });
    if (table.rim && s.rim) add('rim', table.rim.title, baseVariant(table.rim), 1);
    var strips = table.strip ? s.strips : 0;
    if (strips > 0) add('strip', this.t('strips_line', { n: strips }), baseVariant(table.strip), strips);

    var total = lines.reduce(function (sum, l) { return sum + l.price; }, 0);
    var cart = [{ id: tVar.id, quantity: 1 }, { id: sVar.id, quantity: 1 }];
    lines.forEach(function (l) { if (!l.cartSkip && l.kind !== 'table' && l.kind !== 'source') cart.push({ id: l.variantId, quantity: l.qty }); });

    var notes = [], power = find(POWERS, s.power), air = find(AIRS, s.air);
    if (power && power.id >= 1 && power.id <= 3 && source.power > power.id) notes.push(this.t('note_power', { source: source.name, need: POWER_LABEL[source.power], have: POWER_LABEL[power.id] }));
    if (power && (power.id === 0 || power.id === 9)) notes.push(this.t('note_power_unknown', { need: POWER_LABEL[source.power] }));
    if (air && air.id === 'none') notes.push(this.t('note_air_none'));
    if (air && (air.id === 'cap' || air.id === 'unk')) notes.push(this.t('note_air_check'));
    if (noMatch) notes.push(this.t('note_no_match'));
    if (brandTooLight) notes.push(this.t('note_brand_light'));

    return {
      fmtTable: fmtTable, recTable: recTable, table: table, mat: mat, thick: thick, intens: intens, power: power, air: air,
      reqMm: reqMm, brandList: brandList, recSource: recSource, source: source, variantTorches: variantTorches,
      extras: extras, strips: strips, lines: lines, total: total, cart: cart, notes: notes,
      filterRec: !!air && air.id !== 'dry', ans1: !!(fmtTable && mat && thick), ans2: !!(intens && power && air)
    };
  };

  Configurator.prototype.quality = function (src, matId) {
    var v = function (k) { var n = parseFloat(String(src.q[k] || '').replace(',', '.')); return isNaN(n) ? null : n; };
    if (matId !== 'mix') return v(matId);
    var all = [v('staal'), v('rvs'), v('alu')].filter(function (n) { return n != null; });
    return all.length ? Math.min.apply(null, all) : null;
  };

  Configurator.prototype.torchName = function (variantTitle, fallback) {
    var m = variantTitle.match(/(HPA|MPA|UPM)[\s-]?(\d+)/i);
    return m ? fallback + ' ' + m[1].toUpperCase() + '-' + m[2] : fallback;
  };
  Configurator.prototype.sizeLabel = function (t) { return (t.width && t.len) ? t.len + ' × ' + t.width + ' mm' : ''; };
  /* Bedrag in centen → tekst in de valuta van de bezoeker (cur) of een opgegeven valuta. */
  Configurator.prototype.money = function (cents, currency) {
    var cur = currency || this.cur, neg = cents < 0, v = Math.abs(Math.round(cents)) / 100;
    var loc = document.documentElement.lang || 'nl';
    var dec = v % 1 === 0 ? 0 : 2;
    var out;
    try { out = new Intl.NumberFormat(loc, { style: 'currency', currency: cur, minimumFractionDigits: dec, maximumFractionDigits: dec }).format(v); }
    catch (e) { out = cur + ' ' + v.toFixed(dec); }
    return (neg ? '− ' : '') + out;
  };
  /* Lokaal bedrag in centen → euro's (getal, 2 decimalen). null als de koers onbekend is. */
  Configurator.prototype.toEur = function (cents) {
    if (this.cur === this.base) return Math.round(cents) / 100;
    if (!this.rate) return null;
    return Math.round(cents / this.rate) / 100;
  };

  /* ---------- opbouw (één keer) ---------- */
  Configurator.prototype.build = function () {
    var self = this, maxLen = this.maxLen;
    var imgs = this.tables.map(function (t) {
      return '<img class="acfg-stage__table" data-table="' + esc(t.id) + '" style="--s:' + t.scale + '" src="' + esc(t.img || '') + '" alt="Pritec ACROS ' + esc(t.label) + '" loading="eager">';
    }).join('');
    var rects = this.tables.slice().reverse().map(function (t) {
      return '<div class="acfg-fp__rect" data-fp="' + esc(t.id) + '" style="width:' + Math.round(t.len / maxLen * 140) + 'px;height:' + Math.round(t.width / maxLen * 140) + 'px"></div>';
    }).join('');
    this.root.innerHTML =
      '<div class="acfg__wrap">' +
        '<section class="acfg__stage" aria-label="ACROS">' +
          '<div class="acfg-stage__head"><div>' +
            '<span class="acfg-stage__eyebrow">' + esc(this.t('stage_eyebrow')) + '</span>' +
            '<h2 class="acfg-stage__model" data-ref="model"></h2>' +
            '<p class="acfg-stage__sub" data-ref="sub"></p></div>' +
            '<div class="acfg-stage__rec" data-ref="rec">' + icon('check') + '<span data-ref="recText"></span></div>' +
          '</div>' +
          '<div class="acfg-stage__scene">' +
            '<span class="acfg-stage__badge" data-ref="badge"></span>' + imgs +
            '<div class="acfg-stage__source"><img class="acfg-stage__srcimg" data-ref="srcImg" alt=""><div class="acfg-stage__unit" data-ref="srcUnit"></div><span class="acfg-stage__srclabel" data-ref="srcLabel"></span></div>' +
          '</div>' +
          '<div class="acfg-stage__foot">' +
            '<div class="acfg-fp"><span class="acfg-label">' + esc(this.t('fp_label')) + '</span><div class="acfg-fp__box">' + rects + '</div></div>' +
            '<div><span class="acfg-label">' + esc(this.t('chips_label')) + '</span><div class="acfg-chips" data-ref="chips"></div></div>' +
          '</div>' +
        '</section>' +
        '<section class="acfg__panel" data-ref="panel"><nav class="acfg-steps" data-ref="steps" aria-label="' + esc(this.t('nav_steps')) + '">' +
          [1, 2, 3, 4, 5, 6].map(function (n, i) { return '<button type="button" class="acfg-step" data-action="go" data-value="' + i + '"><span class="acfg-step__n">' + n + '</span><span class="acfg-step__t">' + esc(self.t('step_' + n)) + '</span></button>'; }).join('') +
          '<span class="acfg-steps__of" data-ref="stepOf"></span></nav><div class="acfg-panel__inner" data-ref="inner"></div></section>' +
      '</div>';
    this.ref = {};
    this.root.querySelectorAll('[data-ref]').forEach(function (el) { self.ref[el.getAttribute('data-ref')] = el; });
    this.ref.panel.addEventListener('click', this.onClick.bind(this));
    this.ref.panel.addEventListener('input', this.onInput.bind(this));
    this.ref.panel.addEventListener('submit', function (e) { e.preventDefault(); self.next(); });
  };

  /* ---------- weergave ---------- */
  Configurator.prototype.render = function () {
    var c = this.calc();
    this.renderStage(c);
    this.renderPanel(c);
  };

  Configurator.prototype.renderStage = function (c) {
    var r = this.ref, src = c.source;
    r.model.textContent = 'ACROS ' + c.table.label;
    r.sub.innerHTML = '<span>' + esc(this.t('stage_size', { size: this.sizeLabel(c.table) })) + '</span><span>' + esc(src.name) + '</span>';
    r.badge.textContent = this.sizeLabel(c.table);
    r.rec.classList.toggle('is-on', c.ans1 && c.ans2);
    r.recText.textContent = this.t('stage_rec', { model: c.recTable.label, source: c.recSource.name });
    this.root.querySelectorAll('[data-table]').forEach(function (img) { img.classList.toggle('is-on', img.getAttribute('data-table') === c.table.id); });
    this.root.querySelectorAll('[data-fp]').forEach(function (el) { el.classList.toggle('is-on', el.getAttribute('data-fp') === c.table.id); });
    if (src.img) {
      r.srcImg.src = src.img; r.srcImg.alt = src.name; r.srcImg.hidden = false; r.srcUnit.hidden = true;
    } else {
      r.srcImg.hidden = true; r.srcUnit.hidden = false;
      r.srcUnit.style.height = (90 + src.level * 16) + 'px';
      r.srcUnit.innerHTML = esc(src.amp) + '<small>' + esc(src.brand) + '</small>';
    }
    r.srcLabel.textContent = src.name + (src.amp ? ' · ' + src.amp : '');
    r.chips.innerHTML = c.lines.filter(function (l) { return l.kind !== 'table'; }).map(function (l) {
      return '<span class="acfg-chip">' + icon('check', 'ic--sm') + esc(l.name) + '</span>';
    }).join('');
  };

  Configurator.prototype.renderPanel = function (c) {
    var s = this.state, self = this;
    this.ref.steps.hidden = s.step > 5;
    this.ref.steps.querySelectorAll('.acfg-step').forEach(function (btn, i) {
      btn.classList.toggle('is-cur', i === s.step);
      btn.classList.toggle('is-done', i < s.step);
      btn.disabled = i > s.visited;
      if (i === s.step) btn.setAttribute('aria-current', 'step'); else btn.removeAttribute('aria-current');
    });
    this.ref.stepOf.textContent = this.t('step_of', { n: Math.min(s.step + 1, 6), total: 6 });
    this.ref.inner.innerHTML = '<form class="acfg-body" novalidate>' + this['step' + s.step](c) + '</form>' + (s.step < 6 ? this.footer(c) : '');
  };

  Configurator.prototype.opt = function (field, value, pressed, inner, extraCls) {
    return '<button type="button" class="acfg-opt' + (extraCls ? ' ' + extraCls : '') + '" data-action="set" data-field="' + field + '" data-value="' + esc(value) + '" aria-pressed="' + (pressed ? 'true' : 'false') + '">' + inner + '</button>';
  };
  Configurator.prototype.head = function (title, intro) {
    return '<div><h1 class="acfg-h1">' + esc(title) + '</h1>' + (intro ? '<p class="acfg-intro">' + esc(intro) + '</p>' : '') + '</div>';
  };
  Configurator.prototype.q = function (label, cols, inner, after) {
    return '<div class="acfg-q" role="group" aria-label="' + esc(label) + '"><span class="acfg-q__label">' + esc(label) + '</span><div class="acfg-grid acfg-grid--' + cols + '">' + inner + '</div>' + (after || '') + '</div>';
  };

  Configurator.prototype.step0 = function (c) {
    var s = this.state, self = this, maxLen = this.maxLen;
    var formats = this.tables.map(function (t) {
      var w = Math.max(14, Math.round(t.len / maxLen * 54)), hh = Math.max(10, Math.round(t.width / maxLen * 54));
      return self.opt('format', t.id, s.format === t.id, '<span class="acfg-fmt"><span style="width:' + w + 'px;height:' + hh + 'px"></span></span>' + esc(t.formatLabel || self.sizeLabel(t)));
    }).join('');
    var mats = MATERIALS.map(function (m) { return self.opt('material', m.id, s.material === m.id, '<span class="acfg-swatch" style="background:' + m.swatch + '"></span>' + esc(self.t('mat_' + m.id)), 'acfg-opt--row'); }).join('');
    var thicks = THICKS.map(function (t) { return self.opt('thick', t.id, s.thick === t.id, '<span class="acfg-bar" style="height:' + t.bar + 'px"></span>' + esc(self.t('thk_' + t.id))); }).join('');
    return '<div class="acfg-stack">' + this.head(this.t('s1_title'), this.t('s1_intro')) +
      this.q(this.t('q_format'), 4, formats) + this.q(this.t('q_material'), 4, mats) + this.q(this.t('q_thickness'), 4, thicks) + '</div>';
  };

  Configurator.prototype.step1 = function (c) {
    var s = this.state, self = this;
    var ints = INTENS.map(function (d) { return self.opt('intens', d.id, s.intens === d.id, esc(self.t('int_' + d.id)) + '<small>' + esc(self.t('int_' + d.id + '_sub')) + '</small>', 'acfg-opt--left'); }).join('');
    var pows = POWERS.map(function (w) { return self.opt('power', w.id, s.power === w.id, esc(self.powerLabel(w.id))); }).join('');
    var airs = AIRS.map(function (a) { return self.opt('air', a.id, s.air === a.id, esc(self.t('air_' + a.id)), 'acfg-opt--left'); }).join('');
    var other = s.power === 9 ? '<label class="acfg-sr" for="acfg-power-text">' + esc(this.t('power_other_label')) + '</label><input class="acfg-input" id="acfg-power-text" data-input="powerText" value="' + esc(s.powerText) + '" placeholder="' + esc(this.t('power_other_ph')) + '">' : '';
    return '<div class="acfg-stack">' + this.head(this.t('s2_title'), this.t('s2_intro')) +
      this.q(this.t('q_intensity'), 3, ints) + this.q(this.t('q_power'), 5, pows, other) + this.q(this.t('q_air'), 2, airs) + '</div>';
  };

  Configurator.prototype.step2 = function (c) {
    var s = this.state, self = this, t = c.table, src = c.source;
    var modelPills = this.tables.map(function (x) { return '<button type="button" class="acfg-pill" data-action="model" data-value="' + esc(x.id) + '" aria-pressed="' + (x.id === t.id) + '">' + esc(x.label) + '</button>'; }).join('');
    var brands = ['pritec', 'jasic'].filter(function (b) { return self.sources.some(function (x) { return x.brand === b; }); });
    var seg = brands.length > 1 ? '<div class="acfg-seg" role="group" aria-label="' + esc(this.t('brand_label')) + '">' + brands.map(function (b) { return '<button type="button" data-action="brand" data-value="' + b + '" aria-pressed="' + (s.brand === b) + '">' + (b === 'pritec' ? 'Pritec' : 'Jasic') + '</button>'; }).join('') + '</div>' : '';
    var srcPills = c.brandList.map(function (x) { return '<button type="button" class="acfg-pill" data-action="source" data-value="' + esc(x.id) + '" aria-pressed="' + (x.id === src.id) + '">' + esc(x.label) + '</button>'; }).join('');
    var why = [];
    if (c.thick) why.push(this.t('reason_plate', { thickness: this.t('thk_' + c.thick.id) }));
    if (c.mat && c.mat.id !== 'staal') why.push(this.t('mat_' + c.mat.id + '_lc'));
    if (c.intens && c.intens.id === 'dag') why.push(this.t('reason_daily'));
    var q = this.quality(src, c.mat ? c.mat.id : 'staal');
    var srcReason = [why.length ? this.t('reason_for', { list: why.join(', ') }) : '', this.t('reason_power', { power: POWER_LABEL[src.power] }), q ? this.t('reason_q', { mm: q }) : ''].filter(Boolean).join(' ');
    var tableReason = [t.fit, t.id !== c.recTable.id ? this.t('adjusted', { model: c.recTable.label }) : ''].filter(Boolean).join(' ');
    var pros = this.t(s.brand === 'pritec' ? 'pros_pritec' : 'pros_jasic');
    var img = function (url, alt, ph) { return url ? '<img class="acfg-card__img" src="' + esc(url) + '" alt="' + esc(alt) + '" loading="lazy">' : '<span class="acfg-card__ph">' + esc(ph) + '</span>'; };
    var notes = c.notes.length ? '<div class="acfg-note" role="status">' + icon('warn') + '<div>' + c.notes.map(function (n) { return '<p>' + esc(n) + '</p>'; }).join('') + '</div></div>' : '';
    return '<div class="acfg-stack acfg-stack--tight">' + this.head(this.t('s3_title')) +
      '<div class="acfg-card"><div class="acfg-card__row">' + img(t.img, 'ACROS ' + t.label, t.label) +
        '<div class="acfg-card__txt"><span class="acfg-card__kicker">' + esc(this.t('kicker_model')) + '</span><span class="acfg-card__name">ACROS ' + esc(t.label) + ' · ' + esc(this.sizeLabel(t)) + '</span><span class="acfg-card__desc">' + esc(tableReason) + '</span></div>' +
        '<span class="acfg-price">' + this.money(t.base.price) + '</span></div>' +
        '<div class="acfg-pills"><span class="acfg-muted">' + esc(this.t('other_size')) + '</span>' + modelPills + '</div></div>' +
      '<div class="acfg-card"><div class="acfg-card__row">' + img(src.img, src.name, src.amp) +
        '<div class="acfg-card__txt"><span class="acfg-card__kicker">' + esc(this.t('kicker_source')) + '</span><span class="acfg-card__name">' + esc(src.name) + '</span><span class="acfg-card__desc">' + esc(srcReason) + '</span></div>' +
        '<span class="acfg-price">' + this.money(src.base.price) + '</span></div>' +
        '<div class="acfg-pills">' + seg + srcPills + '</div><span class="acfg-muted">' + esc(pros) + '</span></div>' +
      notes + '</div>';
  };

  Configurator.prototype.check = function (action, value, on, name, desc, price, tag) {
    return '<button type="button" class="acfg-check" data-action="' + action + '"' + (value != null ? ' data-value="' + esc(value) + '"' : '') + ' aria-pressed="' + (on ? 'true' : 'false') + '">' +
      '<span class="acfg-box">' + (on ? icon('check', 'ic--sm') : '') + '</span>' +
      '<span class="acfg-check__txt"><span class="acfg-check__name">' + esc(name) + (tag ? '<span class="acfg-tag">' + esc(tag) + '</span>' : '') + '</span>' + (desc ? '<span class="acfg-check__desc">' + esc(desc) + '</span>' : '') + '</span>' +
      '<span class="acfg-price">' + price + '</span></button>';
  };

  Configurator.prototype.step3 = function (c) {
    var s = this.state, src = c.source, rows = '';
    if (c.variantTorches) {
      if (src.vMach) rows += this.check('toggle', 'machineTorch', s.machineTorch, this.torchName(src.vMach.title, this.t('torch_machine')), this.t('torch_machine_desc'), '+ ' + this.money(src.vMach.price - src.base.price), this.t('tag_cnc_rec'));
      if (src.vHand) rows += this.check('toggle', 'handTorch', s.handTorch, this.torchName(src.vHand.title, this.t('torch_hand')), this.t('torch_hand_desc'), '+ ' + this.money(src.vHand.price - src.base.price));
    } else {
      if (src.handIncluded) rows += '<div class="acfg-check acfg-check--static"><span class="acfg-box">' + icon('check', 'ic--sm') + '</span><span class="acfg-check__txt"><span class="acfg-check__name">' + esc(this.t('torch_hand')) + '</span><span class="acfg-check__desc">' + esc(this.t('hand_included_desc')) + '</span></span><span class="acfg-price">' + esc(this.t('included')) + '</span></div>';
      if (src.torch) rows += this.check('toggle', 'machineTorch', s.machineTorch, src.torch.title, this.t('torch_machine_desc'), '+ ' + this.money(baseVariant(src.torch).price), this.t('tag_cnc_rec'));
    }
    if (src.kit) rows += this.check('toggle', 'kit', s.kit, src.kit.title, this.t('kit_desc'), '+ ' + this.money(baseVariant(src.kit).price));
    if (!rows) rows = '<p class="acfg-muted">' + esc(this.t('no_torches')) + '</p>';
    return '<div class="acfg-stack">' + this.head(this.t('s4_title'), this.t('s4_intro2')) + '<div class="acfg-stack acfg-stack--tight">' + rows + '</div></div>';
  };

  Configurator.prototype.step4 = function (c) {
    var s = this.state, self = this, t = c.table, rows = '';
    if (t.laptop) rows += this.check('toggle', 'laptop', s.laptop, this.t('laptop_name'), this.t('laptop_desc'), '+ ' + this.money(t.laptop.price - t.base.price));
    c.extras.forEach(function (e) {
      if (!e.variant) return;
      var rec = e.recommend === 'always' || (e.recommend === 'air' && c.filterRec);
      var row = self.check('extra', e.id, !!s.extras[e.id], e.name, e.desc, '+ ' + self.money(e.variant.price), rec ? self.t('tag_recommended') : '');
      /* productlink: losse <a> naast de knop (geen link-in-knop); url komt uit Liquid en is per taal al vertaald */
      if (e.product && e.product.url) {
        row = '<div class="acfg-xrow">' + row + '<a class="acfg-xlink" href="' + esc(e.product.url) + '" target="_blank" rel="noopener" aria-label="' + esc(self.t('more_info_aria', { name: e.name })) + '">' + esc(self.t('more_info')) + icon('ext', 'ic--xs') + '</a></div>';
      }
      rows += row;
    });
    if (t.rim) rows += this.check('toggle', 'rim', s.rim, t.rim.title, this.t('rim_desc'), '+ ' + this.money(baseVariant(t.rim).price));
    if (t.strip) {
      var sv = baseVariant(t.strip);
      rows += '<div class="acfg-check" aria-pressed="' + (c.strips > 0) + '" role="group" aria-label="' + esc(this.t('strips_name')) + '"><span class="acfg-check__txt"><span class="acfg-check__name">' + esc(this.t('strips_name')) + '</span><span class="acfg-check__desc">' + esc(this.t('strips_each', { price: this.money(sv.price) }) + (t.stripNote ? ' ' + t.stripNote : '')) + '</span></span>' +
        '<span class="acfg-stepper"><button type="button" data-action="strips" data-value="-1" aria-label="' + esc(this.t('strips_less')) + '">−</button><output aria-live="polite">' + c.strips + '</output><button type="button" data-action="strips" data-value="1" aria-label="' + esc(this.t('strips_more')) + '">+</button></span>' +
        '<span class="acfg-price">' + this.money(sv.price * c.strips) + '</span></div>';
    }
    return '<div class="acfg-stack">' + this.head(this.t('s5_title'), this.t('s5_intro')) + '<div class="acfg-stack acfg-stack--tight">' + rows + '</div></div>';
  };

  Configurator.prototype.answersLine = function (c) {
    var s = this.state;
    return [c.fmtTable && this.t('ans_plate', { size: c.fmtTable.formatLabel || this.sizeLabel(c.fmtTable) }), c.mat && this.t('mat_' + c.mat.id + '_lc'), c.thick && this.t('thk_' + c.thick.id),
      c.intens && this.t('int_' + c.intens.id).toLowerCase(), c.power && (c.power.id === 9 ? (s.powerText || this.t('power_9').toLowerCase()) : (c.power.id === 0 ? this.t('power_0').toLowerCase() : this.powerLabel(c.power.id))), c.air && this.t('air_' + c.air.id).toLowerCase()].filter(Boolean).join(' · ');
  };

  Configurator.prototype.step5 = function (c) {
    var s = this.state, self = this;
    var dels = DELIVERIES.map(function (d) { return self.opt('delivery', d.id, s.delivery === d.id, esc(self.t('del_' + d.id)) + '<small>' + esc(self.t('del_' + d.id + '_sub')) + '</small>', 'acfg-opt--left'); }).join('');
    var spec = s.spec ? '<div class="acfg-spec">' + c.lines.map(function (l) { return '<div><span>' + esc(l.name) + '</span><span>' + (l.price ? self.money(l.price) : esc(self.t('included'))) + '</span></div>'; }).join('') +
      '<div><span>' + esc(this.t('del_' + s.delivery)) + '</span><span>' + (s.delivery === 'ship' ? esc(this.t('in_quote')) : this.money(0)) + '</span></div></div>' : '';
    var isMail = s.mode === 'email';
    var mailBtn = s.fallback ? '<a class="acfg-btn acfg-btn--primary acfg-btn--sm" data-mail-fallback href="' + esc(this.mailto(c)) + '">' + esc(this.t('mail_btn')) + '</a>' : '';
    var err = s.error ? '<div class="acfg-note acfg-note--error" role="alert">' + icon('warn') + '<div class="acfg-stack acfg-stack--tight"><p>' + esc(s.error) + '</p>' + mailBtn + '</div></div>' : '';
    var cartLink = this.d.showCart ? ' ' + esc(this.t('cart_text')) + ' <a href="#" data-action="cart">' + esc(this.t('cart_link')) + '</a>.' : '';
    var privacy = this.d.privacyUrl ? ' <a href="' + esc(this.d.privacyUrl) + '" target="_blank" rel="noopener">' + esc(this.t('privacy_link')) + '</a>.' : '';
    return '<div class="acfg-stack acfg-stack--tight">' + this.head(this.t('s6_title'), this.t('s6_intro')) +
      '<div class="acfg-grid acfg-grid--2" role="group" aria-label="' + esc(this.t('delivery_label')) + '">' + dels + '</div>' +
      '<div class="acfg-sum"><span class="acfg-card__txt"><span class="acfg-card__name">' + esc(this.t('sum_complete', { model: c.table.label })) + '</span><span class="acfg-muted">' + esc(this.t('sum_meta', { n: c.lines.length, total: this.money(c.total) })) + '</span></span>' +
        '<button type="button" class="acfg-btn" style="height:34px;font-size:13px" data-action="toggle" data-value="spec" aria-expanded="' + s.spec + '">' + esc(this.t(s.spec ? 'spec_hide' : 'spec_show')) + '</button></div>' + spec +
      '<div class="acfg-answers"><strong>' + esc(this.t('answers_label')) + '</strong> ' + esc(this.answersLine(c)) + '</div>' +
      /* alleen e-mail: de keuze e-mail/telefoon is weggehaald (state.mode blijft altijd 'email') */
      '<div class="acfg-q"><span class="acfg-q__label">' + esc(this.t('contact_q')) + '</span>' +
        '<div class="acfg-grid acfg-grid--2"><div class="acfg-field"><label for="acfg-contact">' + esc(this.t(isMail ? 'label_email' : 'label_phone')) + '</label>' +
          '<input class="acfg-input" id="acfg-contact" data-input="contact" type="' + (isMail ? 'email' : 'tel') + '" autocomplete="' + (isMail ? 'email' : 'tel') + '" value="' + esc(s.contact) + '" placeholder="' + esc(this.t(isMail ? 'ph_email' : 'ph_phone')) + '" required></div>' +
          '<div class="acfg-field"><label for="acfg-name">' + esc(this.t('label_name')) + '</label><input class="acfg-input" id="acfg-name" data-input="name" autocomplete="organization" value="' + esc(s.name) + '"></div></div>' +
        '<div class="acfg-hp" aria-hidden="true"><label for="acfg-website">Website</label><input id="acfg-website" data-input="hp" tabindex="-1" autocomplete="off"></div>' +
      '</div>' + err +
      '<p class="acfg-muted">' + esc(this.t('privacy_text')) + privacy + cartLink + '</p></div>';
  };

  Configurator.prototype.step6 = function (c) {
    var demo = this.d.demoUrl ? '<a class="acfg-btn acfg-btn--primary" href="' + esc(this.d.demoUrl) + '" target="_blank" rel="noopener">' + esc(this.t('demo_btn')) + '</a>' : '';
    return '<div class="acfg-done"><div class="acfg-done__icon">' + icon('check') + '</div>' +
      '<div><h1 class="acfg-h1">' + esc(this.t('done_title')) + '</h1><p class="acfg-intro">' + esc(this.t('done_text', { model: c.table.label, contact: this.state.contact })) + '</p></div>' +
      '<div class="acfg-next"><strong>' + esc(this.t('done_next')) + '</strong><p><b>01</b>' + esc(this.t('done_1')) + '</p><p><b>02</b>' + esc(this.t('done_2')) + '</p><p><b>03</b>' + esc(this.t('done_3')) + '</p></div>' +
      '<div style="display:flex;gap:12px;flex-wrap:wrap">' + demo + '<button type="button" class="acfg-btn" data-action="reset">' + esc(this.t('reset_btn')) + '</button></div></div>';
  };

  Configurator.prototype.footer = function (c) {
    var s = this.state, can = this.canNext(c);
    var key = s.step === 5 ? (s.sending ? 'btn_sending' : 'btn_submit') : (s.step === 1 ? 'btn_advice' : (s.step === 4 ? 'btn_to_offer' : 'btn_next'));
    var vat = num(this.d.vat, 21);
    return '<div class="acfg-foot"><div><span class="acfg-label">' + esc(this.t('foot_price')) + '</span><div class="acfg-total" aria-live="polite">' + this.money(c.total) + '</div><span class="acfg-muted">' + esc(this.t('foot_incl', { price: this.money(c.total * (1 + vat / 100)), vat: vat })) + '</span></div>' +
      '<div class="acfg-foot__btns">' + (s.step > 0 ? '<button type="button" class="acfg-btn acfg-btn--back" data-action="back">' + esc(this.t('btn_back')) + '</button>' : '') +
      '<button type="button" class="acfg-btn acfg-btn--primary" data-action="next" data-ref-next' + (can && !s.sending ? '' : ' disabled') + '>' + esc(this.t(key)) + icon('arrow') + '</button></div></div>';
  };

  Configurator.prototype.validContact = function () {
    var v = this.state.contact.trim();
    return this.state.mode === 'email' ? /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v) : v.replace(/\D/g, '').length >= 9;
  };
  Configurator.prototype.canNext = function (c) {
    var s = this.state;
    if (s.step === 0) return c.ans1;
    if (s.step === 1) return c.ans2;
    if (s.step === 5) return this.validContact();
    return true;
  };

  /* ---------- interactie ---------- */
  Configurator.prototype.onClick = function (e) {
    var mf = e.target.closest('[data-mail-fallback]');
    if (mf) { this.track('configurator_mail_fallback', { configurator_model: this.calc().table.label }); return; }
    var el = e.target.closest('[data-action]');
    if (!el || el.disabled) return;
    var a = el.getAttribute('data-action'), v = el.getAttribute('data-value'), s = this.state;
    if (el.tagName === 'A') e.preventDefault();
    switch (a) {
      case 'set':
        var f = el.getAttribute('data-field');
        s[f] = (f === 'thick' || f === 'power') ? parseInt(v, 10) : v;
        if (f === 'format') s.model = null;
        if (f === 'material' || f === 'thick' || f === 'intens') s.source = null;
        break;
      case 'model': s.model = v; if (s.strips && !find(this.tables, v).strip) s.strips = 0; break;
      case 'brand': s.brand = v; s.source = null; break;
      case 'source': s.source = v; break;
      case 'toggle': s[v] = !s[v]; break;
      case 'extra': s.extras[v] = !s.extras[v]; break;
      case 'strips': s.strips = Math.max(0, Math.min(99, s.strips + parseInt(v, 10))); break;
      case 'go': this.goTo(parseInt(v, 10)); return;
      case 'back': this.goTo(s.step - 1); return;
      case 'next': this.next(); return;
      case 'reset': this.state = this.initial(); this.goTo(0); return;
      case 'cart': this.addToCart(); return;
      default: return;
    }
    this.render();
  };

  Configurator.prototype.onInput = function (e) {
    var k = e.target.getAttribute('data-input');
    if (!k) return;
    if (k === 'hp') { this.hp = e.target.value; return; }
    this.state[k] = e.target.value;
    if (k === 'contact') {
      this.state.error = '';
      var btn = this.ref.panel.querySelector('[data-ref-next]');
      if (btn) btn.disabled = !this.validContact() || this.state.sending;
    }
  };

  Configurator.prototype.goTo = function (n) {
    var s = this.state;
    if (n < 0 || n > 6) return;
    s.step = n; s.visited = Math.max(s.visited, n); s.error = ''; s.fallback = false;
    this.render();
    var body = this.ref.panel.querySelector('.acfg-body');
    if (body) body.scrollTop = 0;
    if (window.matchMedia('(max-width: 989px)').matches) this.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (n < 6) this.track('configurator_step', { configurator_step_number: n + 1, configurator_step_name: DEFAULTS['step_' + (n + 1)] });
    if (n === 2) {
      var c = this.calc();
      this.track('configurator_advice', { configurator_model: c.recTable.label, configurator_source: c.recSource.name });
    }
  };

  Configurator.prototype.next = function () {
    var c = this.calc();
    if (!this.canNext(c)) return;
    if (this.state.step === 5) { this.submit(c); return; }
    this.goTo(this.state.step + 1);
  };

  /* ---------- winkelwagen ---------- */
  Configurator.prototype.addToCart = function () {
    var self = this, c = this.calc();
    var items = c.cart.map(function (i) { return { id: i.id, quantity: i.quantity, properties: { _configurator: 'ACROS ' + c.table.label } }; });
    fetch(this.d.cartAddUrl || '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function () {
        self.track('configurator_add_to_cart', { value: self.toEur(c.total), currency: self.base, value_local: c.total / 100, currency_local: self.cur, configurator_model: c.table.label });
        window.location.href = self.d.cartUrl || '/cart';
      })
      .catch(function () { self.state.error = self.t('err_cart'); self.render(); });
  };

  /* ---------- offerte-aanvraag ---------- */
  Configurator.prototype.attribution = function () {
    var q = new URLSearchParams(window.location.search), out = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid', 'fbclid'].forEach(function (k) { if (q.get(k)) out[k] = q.get(k); });
    if (!out.gclid) {
      var m = document.cookie.match(/(?:^|;\s*)_gcl_aw=([^;]+)/);
      if (m) out.gclid = decodeURIComponent(m[1]).split('.').pop();
    }
    out.referrer = document.referrer || '';
    return out;
  };

  /* De payload gaat altijd in het Nederlands naar sales, ongeacht de taal van de bezoeker. */
  Configurator.prototype.payload = function (c) {
    var s = this.state, D = DEFAULTS, self = this;
    return {
      source: 'acros-configurator',
      submitted_at: new Date().toISOString(),
      page_url: window.location.href,
      language: document.documentElement.lang || 'nl',
      contact: { method: s.mode, value: s.contact.trim(), name: s.name.trim() },
      answers: {
        plate_format: c.fmtTable ? (c.fmtTable.formatLabel || this.sizeLabel(c.fmtTable)) : null,
        material: c.mat ? D['mat_' + c.mat.id] : null,
        thickness: c.thick ? D['thk_' + c.thick.id] : null,
        intensity: c.intens ? D['int_' + c.intens.id] + ' – ' + D['int_' + c.intens.id + '_sub'] : null,
        power: c.power ? (c.power.id === 9 ? 'Anders: ' + s.powerText : (c.power.id === 0 ? D.power_0 : POWER_LABEL[c.power.id])) : null,
        compressed_air: c.air ? D['air_' + c.air.id] : null
      },
      advice: { model: c.recTable.label, plasma_cutter: c.recSource.name, notes: c.notes },
      configuration: {
        model: c.table.label, plasma_cutter: c.source.name,
        /* price / total_excl_vat = EUR (winkelvaluta). *_local = wat de bezoeker zag, in currency. */
        lines: c.lines.map(function (l) { return { name: l.name, sku: l.sku || null, variant_id: l.variantId || null, quantity: l.qty, price: self.toEur(l.price), price_local: l.price / 100 }; }),
        cart_items: c.cart,
        currency: this.cur, base_currency: this.base, fx_rate: this.rate,
        total_local: c.total / 100, total_eur: this.toEur(c.total), total_excl_vat: this.toEur(c.total)
      },
      delivery: D['del_' + s.delivery],
      attribution: this.attribution()
    };
  };

  /* Vangnet: kant-en-klare e-mail (altijd Nederlands, voor sales) als n8n niet reageert. */
  Configurator.prototype.mailto = function (c) {
    var p = this.payload(c), self = this, a = p.answers;
    var body = [
      'Offerte-aanvraag via de ACROS-configurator',
      '',
      'Contact: ' + (p.contact.method === 'email' ? 'e-mail ' : 'telefoon ') + p.contact.value + (p.contact.name ? ' (' + p.contact.name + ')' : ''),
      '',
      'Configuratie:'
    ].concat(c.lines.map(function (l) { return '- ' + l.name + ': ' + (l.price ? self.money(l.price) : 'inbegrepen'); }))
     .concat([
      'Totaal excl. btw: ' + this.money(c.total) + (this.cur !== this.base ? (this.toEur(c.total) != null ? ' (≈ ' + this.money(this.toEur(c.total) * 100, this.base) + ')' : ' (koers onbekend)') : ''),
      'Levering: ' + p.delivery,
      '',
      'Snijwerk: plaat ' + a.plate_format + ' mm, ' + a.material + ', ' + a.thickness + ', ' + a.intensity,
      'Werkplaats: ' + a.power + ', ' + a.compressed_air,
      'Advies: ACROS ' + p.advice.model + ' met ' + p.advice.plasma_cutter,
      '',
      'Pagina: ' + p.page_url
    ]).join('\n');
    return 'mailto:' + (this.d.fallbackEmail || '') + '?subject=' + encodeURIComponent('Offerte-aanvraag ACROS ' + c.table.label) + '&body=' + encodeURIComponent(body);
  };

  Configurator.prototype.submit = function (c) {
    var self = this, s = this.state;
    if (s.sending) return;
    if (this.hp) { s.step = 6; this.render(); return; }
    if (!this.d.webhook) { s.error = this.t('err_webhook', { phone: this.d.phone || '' }); s.fallback = false; this.render(); return; }
    var payload = this.payload(c);
    s.sending = true; s.error = ''; s.fallback = false; this.render();
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 15000);
    /* text/plain: geen extra controleverzoek (CORS-preflight) naar n8n */
    fetch(this.d.webhook, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: JSON.stringify(payload), signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { clearTimeout(timer); if (!r.ok) throw new Error('status ' + r.status); })
      .then(function () {
        var ud = s.mode === 'email' ? { email: s.contact.trim().toLowerCase() } : { phone_number: self.e164(s.contact) };
        /* value altijd in EUR (winkelvaluta); lokale bedrag apart voor analyse */
        self.track('generate_lead', { lead_source: 'acros_configurator', value: self.toEur(c.total), currency: self.base, value_local: c.total / 100, currency_local: self.cur, configurator_model: c.table.label, configurator_source: c.source.name, contact_method: s.mode, user_data: ud });
        s.sending = false; self.goTo(6);
      })
      .catch(function (err) {
        clearTimeout(timer);
        s.sending = false;
        s.fallback = !!self.d.fallbackEmail;
        s.error = s.fallback ? self.t('err_send_fallback') : self.t('err_send', { phone: self.d.phone || '' });
        self.track('configurator_send_error', { error_message: String(err && err.message || err) });
        self.render();
      });
  };

  /* Telefoon naar internationaal formaat (+31...), nodig voor Enhanced Conversions in Google Ads */
  Configurator.prototype.e164 = function (v) {
    var n = String(v || '').replace(/[^\d+]/g, '');
    if (n.indexOf('00') === 0) n = '+' + n.slice(2);
    if (n.charAt(0) === '0') n = ((document.documentElement.lang || 'nl').slice(0, 2) === 'de' ? '+49' : '+31') + n.slice(1);
    return n;
  };

  Configurator.prototype.track = function (event, params) {
    window.dataLayer = window.dataLayer || [];
    var o = { event: event };
    for (var k in params) { if (Object.prototype.hasOwnProperty.call(params, k)) o[k] = params[k]; }
    window.dataLayer.push(o);
  };

  /* ---------- start ---------- */
  function init(scope) {
    (scope || document).querySelectorAll('[data-acfg-section]').forEach(function (root) {
      if (root.__acfg) return;
      var el = document.getElementById('acfg-data-' + root.getAttribute('data-acfg-section'));
      if (!el) return;
      try { root.__acfg = new Configurator(root, JSON.parse(el.textContent)); }
      catch (err) { root.innerHTML = '<div class="acfg__boot">' + esc(DEFAULTS.boot_error) + '</div>'; if (window.console) console.error('[ACROS configurator]', err); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
